import merck from "./merck.png";
import gsk from "./gsk.png";
import victrex from "./victrex.png";
import leeds from "./leeds.jpg";
import soton from "./soton.png";

interface CompanyLogo {
  id: number;
  name: string;
  logo: string;
  alt: string;
}

export const companyLogos: CompanyLogo[] = [
  {
    id: 1,
    name: "Company 1",
    logo: merck,
    alt: "Company 1 Logo",
  },
  {
    id: 2,
    name: "Company 2",
    logo: gsk,
    alt: "Company 2 Logo",
  },
  {
    id: 3,
    name: "Company 3",
    logo: victrex,
    alt: "Company 3 Logo",
  },
  {
    id: 4,
    name: "Company 4",
    logo: leeds,
    alt: "Company 4 Logo",
  },
  {
    id: 5,
    name: "Company 5",
    logo: soton,
    alt: "Company 5 Logo",
  },
];
